module.exports = __webpack_public_path__ + "src/assets/img/1_1art_1part_gallery.ca57a96e.jpg";